var _style, _path, _g, _g2, _g3, _path2, _g4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0052B4;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#F3F3F3;}\n\t.st4{fill:#FF9811;}\n\t.st5{fill:#338AF3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2H256z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.5,33.4c-40,22.8-73.3,56.1-96.1,96.1V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,224.5l-91-91h-31.5v0L256,256h0C256,256,256,234.3,256,224.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M432.9,293.5c7.4-10.1,12.3-22.5,12.3-37.5V144.7c-9.3,7-20.9,11.1-33.4,11.1c-18.2,0-34.4-8.7-44.5-22.3 c-10.2,13.5-26.3,22.3-44.5,22.3c-12.5,0-24.1-4.1-33.4-11.1V256c0,15,4.9,27.3,12.3,37.5H432.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M409.8,235.4c3.5-8.6,6.3-21.3,6.3-27.6c0-10.1-13.2-18.3-13.2-18.3s-13.2,8.2-13.2,18.3 c0,6.3,2.8,18.9,6.3,27.6l-7.6,17.2c4.5,1.8,9.4,2.8,14.5,2.8s10-1,14.5-2.8L409.8,235.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M358.3,179.8c-9.3,1.3-21.6,5.2-27,8.3c-8.8,5.1-9.3,20.6-9.3,20.6s13.7,7.3,22.4,2.3 c5.4-3.1,15-11.8,20.7-19.2l18.7-2c-0.7-4.8-2.2-9.5-4.8-14c-2.6-4.4-5.9-8.2-9.7-11.1L358.3,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.9,252.1c5.7,7.4,15.3,16.1,20.7,19.2c8.8,5.1,22.4-2.3,22.4-2.3s-0.5-15.5-9.3-20.6 c-5.4-3.1-17.8-7.1-27-8.3l-11.1-15.2c-3.8,3-7.1,6.7-9.7,11.1c-2.6,4.4-4.1,9.2-4.8,14L335.9,252.1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.9,289.4c20.8,33.4,68.4,44.5,68.4,44.5s47.6-11.2,68.4-44.5H298.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.c90fe85168c5c3ac0a92e37912ca3a21.svg";
export { ForwardRef as ReactComponent };